import React from 'react';
import {
  Box,
  Grid,
  TextField,
  IconButton,
  Button,
  Typography,
  Stack
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const ActivityQuestionForm = ({
  questions,
  setQuestions,
  activityTitle,
  setActivityTitle,
  handleSubmit
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...questions];
    updated[index][field] = value;
    setQuestions(updated);
  };

  const handleOptionChange = (qIndex, optIndex, value) => {
    const updated = [...questions];
    updated[qIndex].options[optIndex] = value;
    setQuestions(updated);
  };

  const addOption = (index) => {
    const updated = [...questions];
    updated[index].options.push('');
    setQuestions(updated);
  };

  const removeQuestion = (index) => {
    const updated = [...questions];
    updated.splice(index, 1);
    setQuestions(updated);
  };

  const isQuestionValid = (q) => {
    return (
      q.questionText.trim() &&
      q.options.length > 0 &&
      q.options.every((opt) => opt.trim() !== '') &&
      q.explanation.trim() !== '' &&
      typeof q.answerIndex === 'number' &&
      q.answerIndex >= 0
    );
  };

  const addQuestion = () => {
    const lastQuestion = questions[questions.length - 1];
    if (!isQuestionValid(lastQuestion)) {
      alert('Please complete the current question before adding a new one.');
      return;
    }

    const newQuestion = {
      activityKey: 'question-activity',
      questionId: questions.length + 1,
      title: '',
      questionText: '',
      options: [''],
      answerIndex: 0,
      explanation: ''
    };

    setQuestions([...questions, newQuestion]);
  };

  return (
    <Box sx={{ maxHeight: '65vh', overflowY: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Activity Setup
      </Typography>

      <TextField
        label="Activity Title"
        fullWidth
        value={activityTitle}
        onChange={(e) => setActivityTitle(e.target.value)}
        sx={{ mb: 3 }}
      />

      {questions.map((q, qIndex) => (
        <Box key={qIndex} mb={3} p={2} border="1px solid #ccc" borderRadius={2}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="subtitle1">Question {qIndex + 1}</Typography>
            <IconButton onClick={() => removeQuestion(qIndex)} color="error">
              <DeleteIcon />
            </IconButton>
          </Box>

          <Stack spacing={2}>
            <TextField
              label="Title"
              fullWidth
              value={q.title}
              onChange={(e) => handleChange(qIndex, 'title', e.target.value)}
            />
            <TextField
              label="Question Text"
              fullWidth
              multiline
              value={q.questionText}
              onChange={(e) => handleChange(qIndex, 'questionText', e.target.value)}
            />

            <Grid container spacing={2}>
              {q.options.map((opt, optIndex) => (
                <Grid item xs={12} sm={6} key={optIndex}>
                  <TextField
                    label={`Option ${optIndex + 1}`}
                    fullWidth
                    value={opt}
                    onChange={(e) => handleOptionChange(qIndex, optIndex, e.target.value)}
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Button size="small" onClick={() => addOption(qIndex)}>
                  Add Option
                </Button>
              </Grid>
            </Grid>

            <TextField
              type="number"
              label="Answer Index"
              fullWidth
              value={q.answerIndex}
              onChange={(e) =>
                handleChange(qIndex, 'answerIndex', parseInt(e.target.value, 10))
              }
            />
            <TextField
              label="Explanation"
              fullWidth
              multiline
              value={q.explanation}
              onChange={(e) => handleChange(qIndex, 'explanation', e.target.value)}
            />
          </Stack>
        </Box>
      ))}

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={3} justifyContent="space-between">
        <Button variant="outlined" onClick={addQuestion}>
          Add Question
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            textTransform: 'capitalize',
            bgcolor: '#0a0068',
            color: '#ffffff',
            '&:hover': {
              bgcolor: '#0c0082'
            }
          }}
        >
          Save
        </Button>
      </Stack>
    </Box>
  );
};

export default ActivityQuestionForm;
